import { render } from "./MemberManagement.vue?vue&type=template&id=545f82fe"
import script from "./MemberManagement.vue?vue&type=script&lang=js"
export * from "./MemberManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__